<template>
  <div
    ref="navContainer"
    class="header3 text-sm flex-shrink-0 relative py-2 px-4 flex justify-between border-t border-black/10 dark:border-white/10 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-xl"
  >
    <!-- 背景滑动块 -->
    <div
    v-if="bgVisible"
      class="absolute bottom-2.5 rounded-full bg-black/10 dark:bg-neutral-800/70 backdrop-blur-2xl border border-white/30 dark:border-neutral-700/40 shadow-lg shadow-black/5 dark:shadow-black/20 transition-all duration-500 ease-out pointer-events-none"
      :style="{ width: bgWidth + 'px', left: bgLeft + 'px', height: bgHeight + 'px' }"
    ></div>


    <router-link
      v-for="(item, index) in menuItems"
      :key="item.to"
      :to="item.to"
      ref="menuRefs"
      class="relative z-10 flex-1 flex items-center justify-center py-2 transition-all duration-300"
      :class="isActive(item.to) ? 'text-black dark:text-white font-medium' : 'text-gray-600 dark:text-gray-400'"
    >
      <div v-if="item.icon" v-html="item.icon"></div>
      <div v-else>{{ item.label }}</div>
    </router-link>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { storage } from './storage'
const route = useRoute();

const navContainer = ref(null);
const menuRefs = ref([]); // 存放所有菜单项的 DOM

const bgLeft = ref(0);
const bgWidth = ref(0);
const bgHeight = ref(32); // 高度固定和你的样式一致
const bgVisible = ref(false)  // 新增控制背景显示隐藏
//获取存储的上次学习视频id
const ushangci = ref(storage.get('shangci') || 1);

// 监听 ushangci 变化，同步到 localStorage
watch(ushangci, (newVal) => {
  localStorage.setItem('ushangci', newVal);
});
// 监听其他标签页或窗口修改 localStorage
window.addEventListener('storage', (event) => {
  if (event.key === 'ushangci') {
    ushangci.value = event.newValue || 1;
  }
});
onMounted(() => {
  // 初始化时同步一次（可选）
  ushangci.value = localStorage.getItem('ushangci') || 1;
});

// 菜单项数据
const menuItems = [
  { to: '/english', label: '目录' },
  { to: '/Episode/'+ushangci.value, label: '第'+ushangci.value+'期' },
  {
    to: '/search',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
      stroke="currentColor" aria-hidden="true" class="w-5 h-5 text-gray-900 dark:text-gray-100">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>`,
  },
  { to: '/collection/entries', label: '收藏' },
  { to: '/myprofile', label: '我的' },
];

// 判断当前路由是否激活
function isActive(path) {
  return route.path === path;
}

// 更新背景位置和宽度
function updateBackground() {
  nextTick(() => {
    if (!navContainer.value || !menuRefs.value.length) {
      bgVisible.value = false
      return
    }

    const activeIndex = menuItems.findIndex((item) => isActive(item.to))
    if (activeIndex === -1) {
      // 没找到激活项，隐藏背景
      bgVisible.value = false
      return
    }

    const activeEl = menuRefs.value[activeIndex]
    if (!activeEl) {
      bgVisible.value = false
      return
    }

    const navRect = navContainer.value.getBoundingClientRect()
    const activeRect = activeEl.$el ? activeEl.$el.getBoundingClientRect() : activeEl.getBoundingClientRect()

    bgLeft.value = activeRect.left - navRect.left
    bgWidth.value = activeRect.width
    bgVisible.value = true
  })
}

onMounted(() => {
  updateBackground();
});

watch(
  () => route.path,
  () => {
    updateBackground();
  }
);
</script>

<style scoped>
.header3 {
    position: fixed;

    /* top: 0; */
    bottom: 0;

    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
}
.background {
  position: absolute;
  bottom: 10px;
  border-radius: 9999px;
  pointer-events: none;
  transition: left 0.5s ease, width 0.5s ease;
}

.router-link-active {
  color: black !important;
  font-weight: 600;
}
/* 大屏幕（宽度 >= 768px）隐藏 */
@media (min-width: 768px) {
    .header3 {
        display: none !important;
    }
}
</style>